module.exports = __webpack_public_path__ + "Roboto-Light.3b813c2ae0d04909a33a.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Light.woff
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Light.woff
// module chunks = 3